import { useEffect, useState } from "react";
import "../calendar/calendar.scss";

export interface DemoCalendarBlock {
  id: string;
  title: string;
  start: Date;
  end: Date;
}

/**
 * Self-contained, read-only stand-in for HorizontalCalendar.
 * Positions blocks by percentage instead of measured pixel width so it
 * needs no ResizeObserver, and has no click-to-navigate behaviour since
 * the showcase doesn't support opening items.
 */
function HorizontalCalendarDemo({ elements }: { elements: DemoCalendarBlock[] }) {
  const [nowLeft, setNowLeft] = useState("0%");

  useEffect(() => {
    const updateNowIndicator = () => {
      const now = new Date();
      const numeric = now.getHours() + now.getMinutes() / 60;
      setNowLeft(`${(numeric / 24) * 100}%`);
    };
    updateNowIndicator();
    const interval = setInterval(updateNowIndicator, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="horizontal-calendar">
      <div className="horizontal-calendar-content">
        <div
          className="horizontal-calendar-progress"
          style={{ zIndex: 1, width: nowLeft }}
        ></div>

        <div className="horizontal-calendar-grid"></div>

        <div
          className="calendar-now-indicator-vertical"
          style={{ left: nowLeft }}
        >
          <div className="calendar-now-indicator-vertical__top" />
          <p className="calendar-now-indicator-vertical__time">
            {new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </p>
          <div className="calendar-now-indicator-vertical__bottom" />
        </div>

        {elements.map((element) => {
          const startNumeric =
            element.start.getHours() + element.start.getMinutes() / 60;
          const durationHours =
            (element.end.getTime() - element.start.getTime()) / 3600000;

          return (
            <div
              key={element.id}
              className="horizontal-calendar-element"
              style={{
                left: `${(startNumeric / 24) * 100}%`,
                width: `${(durationHours / 24) * 100}%`,
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

export default HorizontalCalendarDemo;
